<template>
  <sui-page>
    <sui-page-header title="조회화면 - 기결함" />
    <sui-page-contents>
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TIT_TTL')" />
          </div>
          <div class="col-xs-11">
            <div class="comm_label">
              {{ approvalTitle }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TIT_DOC_CRTR')" />
          </div>
          <div class="col-xs-11">
            <div class="comm_label">
              {{ drafterSummary }}
            </div>
          </div>
        </div>
      </div>
      <div class="mrB10" />
      <div class="comm_scroll_TB">
        <div class="comm_ListTB">
          <table
            width="100%"
            border="0"
            cellspacing="0"
            cellpadding="0"
          >
            <colgroup>
              <col width="60px">
              <col width="100px">
              <col width="*">
              <col width="220px">
              <col width="220px">
            </colgroup>
            <tr>
              <th>
                <div>{{ $t('MSG_TXT_SN') }}</div>
              </th>
              <th>
                <div>{{ $t('MSG_TIT_ROL') }}</div>
              </th>
              <th>
                <div>{{ $t('MSG_TXT_NAME') }}</div>
              </th>
              <th>
                <div>{{ $t('MSG_TIT_PROC_DTM') }}</div>
              </th>
              <th>
                <div>{{ $t('MSG_TXT_DEPT_NM') }}</div>
              </th>
            </tr>
            <template
              v-for="(user,index) in approvalUserList"
            >
              <tr
                :key="index"
              >
                <td
                  :rowspan="isUserOpinionExist(user.approvalOpinionContent) ? 2: 1"
                >
                  {{ user.approvalParallelOrder }}
                </td>
                <td
                  :rowspan="isUserOpinionExist(user.approvalOpinionContent) ? 2: 1"
                >
                  {{ user.rightApprovalTypeCodeName }}
                </td>
                <td>{{ `${getDisplayText(user.userDisplayLanguageId, user.approvalUserName, user.approvalUserGlobalName)}(${user.approvalUserEmail.replace(/@.*/,'')})` }}</td>
                <td>{{ user.approvalDTM | dateformatToClient }}</td>
                <td>{{ getDisplayText(user.userDisplayLanguageId, user.approvalDepartmentName, user.approvalDepartmentEnglishName) }}</td>
              </tr>
              <tr
                v-if="isUserOpinionExist(user.approvalOpinionContent)"
                :key="`10000${index}`"
              >
                <td colspan="3">
                  <!--
                  <sui-textarea
                    v-model="user.approvalOpinionContent"
                    :readonly="true"
                    :rows="2"
                    :maxlength="1024"
                  />
                  -->
                  {{ user.approvalOpinionContent }}
                </td>
              </tr>
            </template>
          </table>
        </div>
      </div>
      <div class="comm_title_wrap">
        <h4>{{ $t('MSG_TXT_ATTH_FILE') }}</h4>
      </div>
      <cmp-file-attacher
        ref="fileAttacher"
        :pageId="contextPageId"
        :attachGroupId="approvalAttachGroupId"
        :attachDocumentId="approvalAttachDocumentId"
        :disabled="attachDisabled"
        :showAddDeleteBtn="attachShowAddDeleteBtn"
        :enableAdd="attachEnableAdd"
        :deletableOld="attachDeletableOld"
        :showDnHistoryBtn="attachShowDnHistoryBtn"
      />
      <div class="mrB10" />
      <div>
        <sui-web-editor
          ref="webEditor00008"
          class="width100"
          :maxCharCount="maxContentsSize"
          :isViewer="true"
        />
      </div>
    </sui-page-contents>
    <!-- Page Footer -->
    <sui-page-footer>
      <div class="comm_btn_wrap">
        <!-- 취소 -->
        <sui-button
          type="button"
          class="comm_btn_border"
          @click="onClickCancel"
        >
          {{ $t("MSG_BTN_CNCL") }}
        </sui-button>
        <!-- 인쇄 -->
        <sui-button
          type="button"
          class="comm_btn_border"
          @click="onClickPrintApprovalContent"
        >
          {{ $t("MSG_BTN_PRTG") }}
        </sui-button>
        <!-- 현황조회 -->
        <sui-button
          type="button"
          class="comm_btn_solid"
          @click="onClickSearchStatus"
        >
          {{ $t("MSG_TIT_APRV_PRCO_SRCH") }}
        </sui-button>
        <!-- 상신취소 -->
        <sui-button
          v-if="pageInitialData.parentPageId === 'PGE_CML_00001' && isShowCancelProposalBtn"
          type="button"
          class="comm_btn_solid"
          @click="onClickProposalCancel"
        >
          {{ $t("MSG_BTN_APRV_CNCL") }}
        </sui-button>
        <template
          v-if="pageInitialData.parentPageId === 'PGE_CML_00003'"
        >
          <!-- 경로변경 -->
          <sui-button
            v-if="isShowApprovalLineChangeBtn"
            type="button"
            class="comm_btn_solid"
            @click="onClickApprovalLineChange"
          >
            {{ $t("MSG_TIT_APRV_LINE_CHG") }}
          </sui-button>
          <!-- 내용변경 -->
          <sui-button
            v-if="isShowApprovalContentChangeBtn"
            type="button"
            class="comm_btn_solid"
            @click="onClickApprovalContentChange"
          >
            {{ $t("MSG_TIT_APRV_CNTN_CHG") }}
          </sui-button>
          <!-- 반려 -->
          <sui-button
            v-if="isShowApprovalRejectBtn"
            type="button"
            class="comm_btn_solid"
            @click="onClickApprovalReject"
          >
            {{ $t("MSG_BTN_RJT") }}
          </sui-button>
          <!-- 승인(합의) -->
          <sui-button
            type="button"
            class="comm_btn_solid"
            @click="onClickApprove"
          >
            {{ approvalBtnTitle }}
          </sui-button>
        </template>
        <template
          v-if="pageInitialData.parentPageId === 'PGE_CML_00005'"
        >
          <!-- 결재취소 -->
          <sui-button
            v-if="isShowCancelApprovedBtn"
            type="button"
            class="comm_btn_solid"
            @click="onClickCancelApproved"
          >
            {{ $t('MSG_TIT_APRV_CNCL') }}
          </sui-button>
        </template>
      </div>
    </sui-page-footer>
  </sui-page>
</template>
<script>
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CML_00008', // eslint-disable-line vue/name-property-casing
  filters: {
    /**
     * 
     */
    dateformatToClient(value) {
      const result = utils.dateformatToClient(value);
      return utils.isDate(result) ? result : '-';
    },
  },
  extends: BasePage,
  props: {
    closePagePopup: {
      type: Function,
      default: null,
    },
    pageInitialData: {
      type: Object,
      required: false,
      default() {
        return {
          approvalUid: '',
          parentPageId: '',
        };
      },
    },
  },
  data() {
    return {
      approvalTitle: '',
      approvalDraftDTM: '', // 작성일시
      drafterSummary: '', // 작성자정보
      drafterSummary2: '', // 작성자정보2: 승인/합의/반려 의견 팝업에 표시
      maxContentsSize: utils.getConfigurationValue('CFG_CMZ_APRV_CONT_LIMIT_SIZE'),
      // 첨부관련(concerned attachFile)
      approvalAttachDocumentId: '',
      approvalAttachGroupId: utils.isEmpty(this.approvalAttachGroupId) ? 'ATG_CML_APRV_COMMON' : this.approvalAttachGroupId,
      approvalProgressStateCode: '', // 결재진행상태코드
      attachDeletableOld: false,
      attachDisabled: true,
      attachEnableAdd: false,
      attachShowAddDeleteBtn: false,
      attachShowDnHistoryBtn: false,
      approvalUserList: [],
      approvalBtnTitle: this.$t('MSG_BTN_APPR'), // '승인' or '합의'
      isApprovalContentChanged: false, // 내용변경 flag
      isShowApprovalLineChangeBtn: false, // '경로변경' 버튼 제어
      isShowApprovalContentChangeBtn: false, // '내용변경' 버튼 제어
      isShowApprovalRejectBtn: false, // '반려' 버튼 제어
      isShowCancelApprovedBtn: false, // '결재취소' 버튼 제어
      isShowCancelProposalBtn: false, // '상신취소' 버튼 제어
    };
  },
  created() {
    this.originalApprovalUserList = []; // 결재선 변경시에 실제로 변경되었는지 비교하기 위한 목적
    this.originalApprovalContent = ''; // 내용 변경시에 실제로 변경되었는지 비교하기 위한 목적
  },
  mounted() {
    if (utils.trim(this.pageInitialData.approvalUid) === '') {
      // 'approvalUid 가 존재하지 않습니다.'
      utils.messageBox('warning', this.$t('MSG_BTN_CFRM'), utils.strFormat(this.$t('MSG_ALT_IT_NOT_EXIST'), 'approvalId'));
    } else {
      this.loadData();
    }
  },
  methods: {
    confirmCancelApproved() {
      return new Promise(resolve => {
        // '결재 취소하시겠습니까?'
        utils.messageBox('confirm', this.$t('MSG_BTN_CFRM'), this.$t('MSG_ALT_PRGS_APRV_CNCL'), () => {
          resolve(true);
        }, () => {
          resolve(false);
        });
      });
    },
    confirmProposalCancel() {
      return new Promise(resolve => {
        // "상신 취소하시겠습니까?"
        utils.messageBox('confirm', this.$t('MSG_BTN_CFRM'), this.$t('MSG_ALT_PRGS_SUBM_CNCL'), () => {
          resolve(true);
        }, () => {
          resolve(false);
        });
      });
    },
    confirmReject() {
      return new Promise(resolve => {
        // '반려 하시겠습니까?'
        utils.messageBox('confirm', this.$t('MSG_BTN_CFRM'), this.$t('MSG_ALT_BAT_RJT_PRGS'), () => {
          resolve(true);
        }, () => {
          resolve(false);
        });
      });
    },
    /**
     * 세션 langId 와 displayLangId 를 비교하여 두 개의 값중 하나를 return
     */
    getDisplayText(displayLangId = '', localTextValue = '', globalTextValue = '') {
      return this.$store.getters.userInfo.langId === displayLangId ? localTextValue : globalTextValue;
    },
    /**
     * 상신의견 값이 존재하는지 확인하여 true/false 반환
     * check existence of approval opinion text and return true/false
     */
    isUserOpinionExist(opinion = '') {
      return utils.trim(opinion) !== '';
    },
    /**
     * approvalUid 에 해당하는 결재 상세 데이터 조회
     */
    loadData() {
      http.request(this.contextPageId, 'DTS_CML_00004', {
        path: {
          'approval-uid': this.pageInitialData.approvalUid,
        },
        query: {
          finalModificationDTM: this.pageInitialData.finalModificationDTM,
        },
      }).then(res => {
        this.approvalTitle = res.data.approvalTitle;
        // 작성자
        const drafter = utils.find(res.data.approvalUserList, { approvalOrder: 0 });
        this.drafterSummary = `${this.getDisplayText(drafter.userDisplayLanguageId, drafter.approvalUserName, drafter.approvalUserGlobalName)}(${drafter.approvalUserEmail.replace(/@.+/, '')}) / ${this.getDisplayText(drafter.userDisplayLanguageId, drafter.approvalDepartmentName, drafter.approvalDepartmentEnglishName)} / ${utils.dateformatToClient(res.data.approvalDraftDTM)}`;
        this.drafterSummary2 = `${this.getDisplayText(drafter.userDisplayLanguageId, drafter.approvalUserName, drafter.approvalUserGlobalName)}(${drafter.approvalUserEmail.replace(/@.+/, '')}) / ${this.getDisplayText(drafter.userDisplayLanguageId, drafter.approvalDepartmentName, drafter.approvalDepartmentEnglishName)}`;
        this.originalApprovalUserList = utils.clone(res.data.approvalUserList);
        this.approvalUserList = res.data.approvalUserList;  // '경로변경' 대응 오리지널 경로 저장
        this.originalApprovalContent = res.data.approvalContent; // '내용변경' 대응 오리지널 내용 저장
        this.$refs.webEditor00008.setHtml(res.data.approvalContent);
        this.finalModificationDTM = res.data.finalModificationDTM; // 최종변경일시
        this.approvalDraftDTM = utils.dateformatToClient(res.data.approvalDraftDTM);
        this.approvalProgressStateCode = res.data.approvalProgressStateCode;
        // 첨부관련
        this.approvalAttachDocumentId = res.data.approvalAttachDocumentId;
        // 로그인자가 '승인' 혹은 '합의' 판단
        const loginUser = utils.find(this.approvalUserList, { approvalUserId: this.$store.getters.userInfo.userId });
        if ([1, 3, 7, '1', '3', '7'].indexOf(loginUser.rightApprovalTypeCode) >= 0) {
          this.approvalBtnTitle = this.$t('MSG_BTN_APPR');
        } else if ([2, 4, '2', '4'].indexOf(loginUser.rightApprovalTypeCode) >= 0) {
          this.approvalBtnTitle = this.$t('MSG_TXT_AGRM');
        } else {
          this.approvalBtnTitle = '';
        }
        this.isShowApprovalContentChangeBtn = this.getIsApprovalContentChange();
        this.isShowApprovalLineChangeBtn = this.getIsApprovalLineChange();
        this.isShowApprovalRejectBtn = this.getIsApprovalReject();
        this.isShowCancelApprovedBtn = this.getIsCancelApproved();
        this.isShowCancelProposalBtn = this.getIsCancelProposal();
      }).catch(() => {
        this.closePagePopup(true);
      });
    },
    getIsApprovalContentChange() {
      // 결재진행상태코드 가 '1'(진행중) 인지 확인
      if (utils.indexOf([1, '1'], this.approvalProgressStateCode) === -1) {
        return false;
      }
      // config 값을 읽어서 config 값이 'Y'이면 '내용변경' 가능, 'N'이면 불가능
      let cfgVal = utils.getConfigurationValue('CFG_CML_CHG_APRV_CNTN');
      if (['N', 'Y'].indexOf(cfgVal) === -1) {
        cfgVal = 'N'; // default value
      }
      if (cfgVal === 'N') {
        return false;
      }

      // 로그인자가 '결재', '합의', '병렬합의', '병렬결재' 일 경우에만 가능
      const loginUser = utils.find(this.approvalUserList, { approvalUserId: this.$store.getters.userInfo.userId });
      return [1, '1', 2, '2', 4, '4', 7, '7'].indexOf(loginUser.rightApprovalTypeCode) >= 0;
    },
    getIsApprovalLineChange() {
      // 결재진행상태코드 가 '1'(진행중) 인지 확인
      if (utils.indexOf([1, '1'], this.approvalProgressStateCode) === -1) {
        return false;
      }
      // config 값을 읽어서 config 값이 'Y'이면 '결재경로변경' 가능, 'N'이면 불가능
      let cfgVal = utils.getConfigurationValue('CFG_CML_CHG_APRV_LINE');
      if (['N', 'Y'].indexOf(cfgVal) === -1) {
        cfgVal = 'N'; // default value
      }
      if (cfgVal === 'N') {
        return false;
      }

      // 로그인자가 '결재', '합의', '병렬합의', '병렬결재' 일 경우에만 가능
      const loginUser = utils.find(this.approvalUserList, { approvalUserId: this.$store.getters.userInfo.userId });
      return [1, '1', 2, '2', 4, '4', 7, '7'].indexOf(loginUser.rightApprovalTypeCode) >= 0;
    },
    getIsApprovalReject() {
      // 결재진행상태코드 가 '1'(진행중) 인지 확인
      if (utils.indexOf([1, '1'], this.approvalProgressStateCode) === -1) {
        return false;
      }

      // '후결'권자 반려가능 여부 check
      const loginUser = utils.find(this.approvalUserList, { approvalUserId: this.$store.getters.userInfo.userId });
      if (utils.indexOf([3, '3'], loginUser.rightApprovalTypeCode) > -1 && utils.getConfigurationValue('CFG_CML_RJT_AFAP') !== 'Y') {
        return false;
      }

      // 반려는 로그인자가 '결재', '합의', '병렬합의', '병렬결재' 일 경우에만 가능
      return [1, '1', 2, '2', 3, '3', 4, '4', 7, '7'].indexOf(loginUser.rightApprovalTypeCode) >= 0;
    },
    getIsCancelApproved() {
      // 결재진행상태코드 가 '1'(진행중) 인지 확인
      if (utils.indexOf([1, '1'], this.approvalProgressStateCode) === -1) {
        return false;
      }

      // 다음 결재권자가 진행했는지 확인
      const loginUser = utils.find(this.approvalUserList, { approvalUserId: this.$store.getters.userInfo.userId });
      let isNextApproved = false;
      utils.forEach(this.approvalUserList, user => {
        if (user.approvalOrder > loginUser.approvalOrder
          && user.approvalParallelOrder > loginUser.approvalParallelOrder
          && [1, '1', 2, '2', 4, '4', 7, '7'].indexOf(user.rightApprovalTypeCode) > -1
          && user.approvalYn === 'Y') {
          isNextApproved = true;
        }
      });
      if (isNextApproved) {
        return false;
      }
      return true;
    },
    getIsCancelProposal() {
      // 결재진행상태코드 가 '1'(진행중) 인지 확인
      if (utils.indexOf([1, '1'], this.approvalProgressStateCode) === -1) {
        return false;
      }

      let isNotProcessed = true;
      // 결재사용자별로 결재 진행상태를 확인하여 최종적으로 상신취소 가능한지 결정 
      utils.forEach(this.approvalUserList, user => {
        // 결재사용자 중 결재권유형이 "결재", "합의", "병렬합의", "병렬결재"인 사용자들이 확인 대상  "최초의 결재 이전" 인지, "최종 완료 이전" 인지 check 
        if (['1', '2', '4', '7'].indexOf(user.rightApprovalTypeCode) >= 0) {
          // 상신 이후 진행된 결재가 하나도 없는지 확인
          if (`${user.rightApprovalTypeCode}0` !== user.rightApprovalTypeStateCode) {
            isNotProcessed = false;
          }
        }
      });
      // config 값을 읽어서 config 값이 '0'이면 '결재 이전' 에 취소 가능, '1'이면 '완료 이전' 에 취소 가능
      let cfgVal = utils.getConfigurationValue('CFG_CML_CNCL_SUBM');
      if (['0', '1'].indexOf(cfgVal) === -1) {
        cfgVal = '0'; // default value
      }
      // config 값이 '0'이고 결재/합의가 한건이라도 지나간 상태라면 취소 불가
      if (cfgVal === '0' && !isNotProcessed) {
        return false;
      }
      return true;
    },
    /**
     * 내용변경
     */
    onClickApprovalContentChange() {
      if (utils.getConfigurationValue('CFG_CML_CHG_APRV_CNTN') !== 'Y') {
        // '내용변겅을 허용하지 않습니다(환경설정).'
        utils.messageBox('warning', this.$t('MSG_BTN_CFRM'), this.$t('MSG_ALT_NPMSN_APRV_CNTN'), () => {
          this.closePagePopup();
        });
      } else {
        utils.openLayerPopup('PGE_CML_00010', obj => {
          if (obj && obj.isChanged === true) {
            this.isApprovalContentChanged = true;
            this.$refs.webEditor00008.setHtml(obj.approvalContent);
          }
        }, {
          pageInitialData: {
            approvalUid: this.pageInitialData.approvalUid,
            approvalTitle: this.approvalTitle,
            approvalContent: this.$refs.webEditor00008.getHtml(),
            approvalDraftDTM: this.approvalDraftDTM,
            drafterUserInfo: this.approvalUserList[0],
          },
          size: 'xlg',
        });
      }
    },
    /**
     * 경로변경
     */
    onClickApprovalLineChange() {
      if (utils.getConfigurationValue('CFG_CML_CHG_APRV_LINE') !== 'Y') {
        // '경로변경을 허용하지 않습니다(환경설정).'
        utils.messageBox('warning', this.$t('MSG_BTN_CFRM'), this.$t('MSG_ALT_NPMSN_APRV_LINE_CHG'), () => {
          this.closePagePopup();
        });
      } else {
        utils.openLayerPopup('PGE_CML_00009', obj => {
          if (obj && obj.isChanged === true) {
            const loginUserIndex = utils.findIndex(this.approvalUserList, { approvalUserId: this.$store.getters.userInfo.userId });
            utils.remove(this.approvalUserList, (user, index) => index > loginUserIndex);
            this.approvalUserList = utils.concat(this.approvalUserList, utils.remove(obj.approvalLineList, (user, index) => index > loginUserIndex));
          }
        }, {
          pageInitialData: {
            approvalUid: this.pageInitialData.approvalUid,
            approvalTitle: this.approvalTitle,
            approvalDraftDTM: this.approvalDraftDTM,
            approvalUserList: this.approvalUserList,
          },
          size: 'xlg',
        });
      }
    },
    /**
     * 반려
     */
    async onClickApprovalReject() {
      let goNext = true;

      // '후결'권자 반려가능 여부 check
      const loginUser = utils.find(this.approvalUserList, { approvalUserId: this.$store.getters.userInfo.userId });
      if (utils.indexOf([3, '3'], loginUser.rightApprovalTypeCode) > -1 && utils.getConfigurationValue('CFG_CML_RJT_AFAP') !== 'Y') {
        // "후결 반려는 허용되지 않습니다(환경설정)."
        utils.messageBox('warning', this.$t('MSG_BTN_CFRM'), this.$t('MSG_ALT_NOT_PSBL_AFAP_RJT'));
        return false;
      }

      const opinionObj = await this.openApprovalOpinionPopup(3);
      if (!opinionObj || opinionObj.goNext !== true) {
        return false;
      }

      // '반려 하시겠습니까?'
      goNext = await this.confirmReject();
      if (goNext === false) return false;

      http.request(this.contextPageId, 'DTS_CML_00011', {
        path: {
          'approval-uid': this.pageInitialData.approvalUid,
        },
        data: {
          approvalOpinionContent: opinionObj.approvalOpinionContent,
          finalModificationDTM: this.finalModificationDTM,
          // approvalContent: this.$refs.webEditor00008.getHtml(),
          approvalContent: this.isApprovalContentChanged ? this.$refs.webEditor00008.getHtml() : '',
          approvalUserList: [],
        },
        query: {
          userPasswordValue: opinionObj.password,
        },
      }).then(() => {
        // '반려 되었습니다.'
        utils.messageBox('success', this.$t('MSG_TXT_SUC'), this.$t('MSG_ALT_REJECT_DATA'), () => {
          this.closePagePopup(true);
        });
      });
      return true;
    },
    /**
     * 승인(합의)
     */
    async onClickApprove() {
      // 로그인자가 '승인'자 or '합의'자 인지 판단
      const loginUser = utils.find(this.approvalUserList, { approvalUserId: this.$store.getters.userInfo.userId });
      let typeNo = 0;
      let confirmMsg = '';
      let successMsg = '';
      if ([1, 3, 7, '1', '3', '7'].indexOf(loginUser.rightApprovalTypeCode) >= 0) {
        typeNo = 1;
        // '승인하시겠습니까?'
        confirmMsg = this.$t('MSG_ALT_APPR');
        // '승인 되었습니다.'
        successMsg = this.$t('MSG_ALT_APPROVED');
      } else if ([2, 4, '2', '4'].indexOf(loginUser.rightApprovalTypeCode) >= 0) {
        typeNo = 2;
        // '합의하시겠습니까?'
        confirmMsg = this.$t('MSG_ALT_AGRM');
        // '합의 되었습니다.'
        successMsg = this.$t('MSG_TXT_AGRM_CPLT');
      } else {
        // '권한이 없습니다.'
        utils.messageBox('warning', this.$t('MSG_BTN_CFRM'), this.$t('MSG_ALT_NO_AUTH'));
        return false;
      }

      const opinionObj = await this.openApprovalOpinionPopup(typeNo);
      if (!opinionObj || opinionObj.goNext !== true) {
        return false;
      }

      // 파라미터 구성
      const approvalUidList = [];
      approvalUidList.push({
        approvalUid: this.pageInitialData.approvalUid,
        approvalOpinionContent: opinionObj.approvalOpinionContent,
        finalModificationDTM: this.finalModificationDTM,
        approvalContent: this.isApprovalContentChanged ? this.$refs.webEditor00008.getHtml() : '',
        approvalUserList: [],
      });
      // 결재선 변경 확인 후 결재선 데이터 추가
      let isSame = true;
      if (this.originalApprovalUserList.length !== this.approvalUserList.length) {
        isSame = false;
      } else {
        utils.forEach(this.originalApprovalUserList, (oUser, index) => {
          if (oUser.approvalUserId !== this.approvalUserList[index].approvalUserId
            || oUser.approvalParallelOrder !== this.approvalUserList[index].approvalParallelOrder
            || oUser.rightApprovalTypeCodeName !== this.approvalUserList[index].rightApprovalTypeCodeName
            || oUser.approvalUserName !== this.approvalUserList[index].approvalUserName
            || oUser.approvalUserEmail !== this.approvalUserList[index].approvalUserEmail) {
            isSame = false;
          }
        });
      }
      if (!isSame) {
        approvalUidList[0].approvalUserList = this.approvalUserList;
      }

      utils.messageBox('confirm', this.$t('MSG_BTN_CFRM'), confirmMsg, () => {
        http.request(this.contextPageId, 'DTS_CML_00010', {
          data: approvalUidList,
          query: {
            userPasswordValue: opinionObj.password,
          },
        }).then(() => {
          utils.messageBox('success', this.$t('MSG_BTN_CFRM'), successMsg, () => {
            this.closePagePopup(true);
          });
        });
      });

      return true;
    },
    /**
     * '취소' 버튼 click event handler
     */
    onClickCancel() {
      this.closePagePopup('');
    },
    /**
     * '결재취소' 버튼 click event handler
     */
    async onClickCancelApproved() {
      // 결재진행상태코드 가 '1'(진행중) 이 아닐 경우 경고 메시지 이후 진행중단
      if (utils.indexOf([1, '1'], this.approvalProgressStateCode) === -1) {
        // '진행중인 결재건만 처리가 가능합니다.'
        utils.messageBox('warning', this.$t('MSG_BTN_CFRM'), this.$t('MSG_ALT_PSBL_PROC_PRGS_APRV'));
        return false;
      }

      // 다음 결재권자가 진행했는지 확인
      const loginUser = utils.find(this.approvalUserList, { approvalUserId: this.$store.getters.userInfo.userId });
      let isNextApproved = false;
      utils.forEach(this.approvalUserList, user => {
        if (user.approvalOrder > loginUser.approvalOrder
          && user.approvalParallelOrder > loginUser.approvalParallelOrder
          && [1, '1', 2, '2', 4, '4', 7, '7'].indexOf(user.rightApprovalTypeCode) > -1
          && user.approvalYn === 'Y') {
          isNextApproved = true;
        }
      });
      if (isNextApproved) {
        // '결재취소 할 수 없습니다.'
        utils.messageBox('warning', this.$t('MSG_BTN_CFRM'), this.$t('MSG_ALT_CANNOT_APRV_CNCL'));
        return false;
      }

      // 진행여부 확인
      const result = await this.confirmCancelApproved();
      if (result === false) return false;

      http.request(this.contextPageId, 'DTS_CML_00016', {
        path: {
          'approval-uid': this.pageInitialData.approvalUid,
        },
        data: {
          finalModificationDTM: this.finalModificationDTM,
        },
      }).then(() => {
        // '결재취소 되었습니다.'
        utils.messageBox('success', this.$t('MSG_TXT_SUC'), this.$t('MSG_ALT_CPLT_APRV_CNCL'), () => {
          this.closePagePopup(true);
        });
      });

      return true;
    },
    /**
     * '상신취소' 버튼 click event handler
     */
    async onClickProposalCancel() {
      /*
      if ([1, '1'].indexOf(this.approvalProgressStateCode) === -1) {
        // '상신취소 할 수 없습니다.'
        utils.messageBox('warning', this.$t('MSG_BTN_CFRM'), this.$t('MSG_ALT_CANNOT_SUBM_CNCL'));
        return false;
      }
      */
      let result = await this.confirmProposalCancel();
      if (!result) return false;
      result = await this.validateProposalCancel();
      if (!result) return false;

      http.request(this.contextPageId, 'DTS_CML_00006', {
        path: {
          'approval-uid': this.pageInitialData.approvalUid,
        },
        data: {
          finalModificationDTM: this.finalModificationDTM,
        },
      }).then(() => {
        // '상신취소 되었습니다.'
        utils.messageBox('success', this.$t('MSG_TXT_SUC'), this.$t('MSG_ALT_CPLT_SUBM_CNCL'), () => {
          this.closePagePopup(true);
        });
      });
      return true;
    },
    /**
     * 결재내용 인쇄팝업
     */
    onClickPrintApprovalContent() {
      utils.openWindowPopup('PGE_CML_00016', {
        approvalUid: this.pageInitialData.approvalUid,
      }, null, {
        top: 100, left: 300, height: 700, width: 915,
      });
    },
    /**
     * 현황조회
     */
    onClickSearchStatus() {
      utils.openLayerPopup('PGE_CML_00013', null, {
        pageInitialData: {
          approvalUid: this.pageInitialData.approvalUid,
        },
        size: 'xlg',
      });
    },
    /**
     * 의견 팝업 오픈
     * open approval opinion popup
     */
    openApprovalOpinionPopup(typeNo) {
      return new Promise(resolve => {
        utils.openLayerPopup('PGE_CML_00012', approvalOpinionObj => {
          resolve(approvalOpinionObj);
        }, {
          pageInitialData: {
            approvalTitle: this.approvalTitle,
            drafterSummary: this.drafterSummary2,
            opinionTypeNo: typeNo, // 1: 승인, 2: 합의, 3: 반려
          },
          size: 'md',
        });
      });
    },
    /**
     * '상신취소' 가능한지 검사
     */
    validateProposalCancel() {
      // this.approvalProgressStateCode = this.approvalProgressStateCode;
      return new Promise(resolve => {
        // "결재진행상태코드" 가 "진행중" 이 아니면 예외 발생
        if (this.approvalProgressStateCode !== '1') {
          // "진행중인 결재건만 처리가 가능합니다."
          utils.messageBox('warning', this.$t('MSG_BTN_CFRM'), this.$t('MSG_ALT_PSBL_PROC_PRGS_APRV'));
          resolve(false);
          return false;
        }

        let isNotProcessed = true;
        // 결재사용자별로 결재 진행상태를 확인하여 최종적으로 상신취소 가능한지 결정 
        utils.forEach(this.approvalUserList, user => {
          // 결재사용자 중 결재권유형이 "결재", "합의", "병렬합의", "병렬결재"인 사용자들이 확인 대상  "최초의 결재 이전" 인지, "최종 완료 이전" 인지 check 
          if (['1', '2', '4', '7'].indexOf(user.rightApprovalTypeCode) >= 0) {
            // 상신 이후 진행된 결재가 하나도 없는지 확인
            if (`${user.rightApprovalTypeCode}0` !== user.rightApprovalTypeStateCode) {
              isNotProcessed = false;
            }
          }
        });
        // config 값을 읽어서 config 값이 '0'이면 '결재 이전' 에 취소 가능, '1'이면 '완료 이전' 에 취소 가능
        let cfgVal = utils.getConfigurationValue('CFG_CML_CNCL_SUBM');
        if (['0', '1'].indexOf(cfgVal) === -1) {
          cfgVal = '0'; // default value
        }
        // config 값이 '0'이고 결재/합의가 한건이라도 지나간 상태라면 예외 발생
        if (cfgVal === '0' && !isNotProcessed) {
          // "상신취소 할 수 없습니다."
          utils.messageBox('warning', this.$t('MSG_BTN_CFRM'), this.$t('MSG_ALT_CANNOT_SUBM_CNCL'), () => {
            resolve(false);
          });
        } else {
          resolve(true);
        }
      });
    },
  },
};
</script>
<style scoped>
</style>
